import React from 'react'
import { Header } from '../../Header'
import { Gender } from '../Gender'
import { BirthDate } from '../BirthDate'

export class Container extends React.Component {
  render () {
    return [
      <Header key='header'>Dodatni podaci</Header>,
      <Gender key='gender' />,
      <BirthDate key='birthDate' />
    ]
  }
}

Container.displayName = 'AdditionalInfo'
